import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

export const SmallCompanyPanel = ({ onEdit }) => {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle");
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return setError("Saisissez une adresse e-mail valide.");
        setError("");
        setState("sending");
        try {
            await api.post("/newsletter", { email, source: "simulator-lt2", revenue_range: "lt2" });
            setState("done");
        } catch {
            setState("idle");
            setError("L'inscription n'a pas abouti. Merci de réessayer dans quelques minutes.");
        }
    };

    return (
        <div className="flex flex-col gap-4 animate-fade-up" data-testid="sim-small-company">
            <span className="text-xs font-semibold uppercase tracking-[0.14em] text-gold-text">Votre estimation</span>
            <h2 className="m-0 text-[22px] md:text-[28px] font-bold leading-[1.25] tracking-[-0.015em] text-navy">
                FOD by DMB Partners n'accompagne pas encore les entreprises de cette taille.
            </h2>
            <p className="m-0 text-base leading-relaxed text-grey-text">
                Nous intervenons aujourd'hui à partir de 2 M€ de chiffre d'affaires. Abonnez-vous : vous recevrez nos décryptages sur les frais bancaires et serez prévenu dès que nous accompagnerons les entreprises de votre taille.
            </p>
            {state === "done" ? (
                <div role="status" data-testid="sim-subscribed" className="flex items-center gap-3 bg-sand rounded-[10px] px-4 py-3.5 text-[15px] text-navy animate-fade-up">
                    <CheckCircle2 size={20} className="text-gold-text shrink-0" />
                    C'est noté. Vous recevrez notre prochaine publication.
                </div>
            ) : (
                <form onSubmit={submit} noValidate className="flex flex-col gap-2.5" data-testid="sim-subscribe-form">
                    <label htmlFor="sim-sub" className="text-sm font-semibold text-navy">E-mail professionnel</label>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <input
                            id="sim-sub"
                            type="email"
                            autoComplete="email"
                            placeholder="prenom@societe.fr"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="sim-subscribe-input"
                            className="w-full sm:flex-1 min-w-0 h-[52px] border-[1.5px] border-border-strong rounded-[10px] px-3.5 text-[15px] text-navy bg-white outline-none focus:border-navy transition-colors"
                        />
                        <button type="submit" data-testid="sim-subscribe-submit" className="h-[52px] px-6 rounded-[10px] bg-gold text-navy text-base font-semibold inline-flex items-center justify-center gap-2 transition-[transform,box-shadow] hover:-translate-y-[1px] hover:shadow-lg">
                            {state === "sending" && <Loader2 size={16} className="animate-spin" />}
                            M'abonner
                        </button>
                    </div>
                    {error && <span role="alert" data-testid="sim-subscribe-error" className="text-sm text-error">{error}</span>}
                    <span className="text-xs leading-relaxed text-grey-text-soft">
                        En vous abonnant, vous acceptez de recevoir nos décryptages par e-mail. Désinscription possible à tout moment. Votre adresse n'est jamais transmise à votre banque ni à des tiers.{" "}
                        <Link to="/politique-de-confidentialite" className="text-navy underline underline-offset-2">Politique de confidentialité</Link>
                    </span>
                </form>
            )}
            <div className="border-t border-border-soft pt-4 text-center">
                <button type="button" onClick={onEdit} data-testid="sim-edit-answers" className="text-[15px] text-grey-text underline underline-offset-4 hover:text-navy transition-colors">Modifier mes réponses</button>
            </div>
        </div>
    );
};
